import { useEffect } from 'react'

export type SaveShortcutListenerProps = {
  disabled?: boolean
  onSave: () => void
}

export const SaveShortcutListener = ({ disabled = false, onSave }: SaveShortcutListenerProps) => {
  const handleKeyDown = (e: KeyboardEvent) => {
    const isMac = navigator.platform.match('Mac')

    if (e.key.toLowerCase() === 's' && (isMac ? e.metaKey : e.ctrlKey) && !disabled) {
      e.preventDefault()
      onSave()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)

    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [onSave, disabled])

  return null
}
